<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />
    <vc-layout :spacing="8">
      <vc-col :span="12" sm24>
        <category-list :title="$store.getters.langKey('gettingStarted')" :span="12" type="getting-started" :sort="false" color="primary" />
        <category-list :title="$store.getters.langKey('formElements')" :span="12" type="form-elements" color="primary" />
        <category-list :title="$store.getters.langKey('layout')" :span="12" type="layout" color="primary" />
        <category-list :title="$store.getters.langKey('directives')" :span="12" type="directives" color="primary" />
      </vc-col>
      <vc-col :span="12" sm24>
        <category-list :title="$store.getters.langKey('uiComponents')" type="components" color="primary" />
        <category-list :title="$store.getters.langKey('stylesAndColors')" :span="12" type="style" color="primary" />
      </vc-col>
    </vc-layout>
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'IndexPage',
  mixins: [
    methods
  ],
  data () {
    return {
      title: null,
      description: null
    }
  },
  mounted () {
    this.getPage()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/index.vue